module.exports = __webpack_public_path__ + "static/media/squint_logo.b96a4987.svg";